import { Eye } from "lucide-react";

export default function ViewButton({
  label = "View",
  onClick,
  size = "sm",      // sm | md
  className = "",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-lg border border-blue-200 
        bg-blue-50 font-semibold text-blue-700 hover:bg-blue-100 
        focus:outline-none focus:ring-2 focus:ring-blue-200
        ${size === "sm" ? "px-2 py-1.5 text-[10px]" : "px-2 py-1 text-[10px]"}
        ${className}`}
    >
      {/* <Eye className={size === "sm" ? "h-4 w-4" : "h-5 w-5"} /> */}
      {label}
    </button>
  );
}
